import { motion } from "framer-motion";
import { HiOutlineCheck, HiOutlineMinus } from "react-icons/hi";
import { twMerge } from "tailwind-merge";

const Checkbox = ({
  isChecked,
  onChange,
  isDisabled = false,
  color = "primary600",
  rounded = "md",
  size = "md",
  isSome = false,
}) => {
  // Base styles
  const base =
    "appearance-none border border-gray300 transition-all duration-150";
  const disabled = isDisabled ? "bg-gray100 border-gray300" : "";
  const sizes = {
    sm: "size-4",
    md: "size-5",
  };
  const roundings = {
    full: "rounded-full",
    md: "rounded-md",
  };

  // Colors / effects
  const colorVariants = {
    primary600:
      "checked:border-primary600 checked:bg-primary100 hover:shadow-[0px_0px_0px_4px_#F4EBFF]",
  };

  const checkboxClass = twMerge(
    base,
    sizes[size],
    roundings[rounded],
    colorVariants[color],
    disabled,
    "cursor-[inherit]"
  );

  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={() => !isDisabled && onChange && onChange(!isChecked)}
      className={twMerge(
        "relative flex w-fit items-center",
        isDisabled ? "pointer-events-none" : "cursor-pointer"
      )}
    >
      <input
        type="checkbox"
        checked={isChecked}
        readOnly
        className={checkboxClass}
      />
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        {isChecked && (
          <>
            {isSome ? (
              <HiOutlineMinus className="text-primary600" />
            ) : (
              <HiOutlineCheck className="text-primary600" />
            )}
          </>
        )}
      </div>
    </button>
  );
};

export default Checkbox;
